import { REQUEST_TOKEN_STATUS, IS_REQUESTING_TOKEN } from './lightspeedTypes';

const defaultState = {
  isLightspeedConnected: false,
  isRequesting: false,
};

export default function (state = { ...defaultState }, action) {
  switch (action.type) {
    case REQUEST_TOKEN_STATUS:
      return {
        ...state,
        isLightspeedConnected: action.payload,
      };
    case IS_REQUESTING_TOKEN:
      return {
        ...state,
        isRequesting: action.payload,
      };
    default:
      return state;
  }
}
